import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// La langue ne choisit que la zone d'affichage par défaut ; le pays saisi au tunnel fait foi ensuite.
export const zoneFromLang = (lang) => {
  if (lang === 'it') return 'IT';
  if (lang === 'ar' || lang === 'en') return 'AE';
  return 'FR';
};

export const ZONE_LABELS = {
  FR: 'France — TVA 20 %',
  IT: 'Italie — TVA 22 %',
  AE: 'Émirats arabes unis — TVA 5 %, devis via revendeur',
};

const FALLBACK = { FR: { currency: 'EUR', vatRate: 20 }, IT: { currency: 'EUR', vatRate: 22 }, AE: { currency: 'AED', vatRate: 5 } };

export const formatAmount = (value, currency) => {
  const n = Number(value || 0).toLocaleString(currency === 'AED' ? 'en-US' : 'fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return currency === 'AED' ? `${n} AED` : `${n} €`;
};

// TVA et devise viennent du serveur : aucun taux ni taux de change dans le front.
export const usePricing = (lang, countryOverride) => {
  const zone = countryOverride || zoneFromLang(lang);
  const [data, setData] = useState({
    zone,
    currency: FALLBACK[zone]?.currency || 'EUR',
    vatRate: FALLBACK[zone]?.vatRate || 20,
    checkoutEnabled: zone !== 'AE',
    prices: {},
    byId: {},
  });

  useEffect(() => {
    let alive = true;
    axios.get(`${BACKEND_URL}/api/public/pricing`, { params: { country: zone } })
      .then((res) => { if (alive) setData(res.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [zone]);

  const fmt = (value) => formatAmount(value, data.currency);
  const htOf = (product) =>
    data.byId?.[product?.id]?.priceHT ?? data.prices?.[product?.slug]?.priceHT ?? product?.price ?? 0;
  const ttcOf = (product) =>
    data.byId?.[product?.id]?.priceTTC ?? data.prices?.[product?.slug]?.priceTTC ??
    Math.round((product?.price || 0) * (1 + data.vatRate / 100) * 100) / 100;
  const vatOn = (ht) => Math.round(ht * data.vatRate) / 100;
  const ttcOn = (ht) => Math.round(ht * (100 + data.vatRate)) / 100;

  return { ...data, fmt, htOf, ttcOf, vatOn, ttcOn };
};
